import { menu } from "./navegacao";
import { ICONES_DISPONIVEIS, type IconeMenu } from "./iconesDisponiveis";

export type { IconeMenu } from "./iconesDisponiveis";

const {
  ArrowDownCircle,
  ArrowLeftRight,
  ArrowUpCircle,
  Banknote,
  BookOpenCheck,
  Boxes,
  Briefcase,
  Building2,
  Calculator,
  Calendar,
  CalendarClock,
  ClipboardCheck,
  ClipboardList,
  Contact,
  CreditCard,
  FileBarChart,
  FileCheck2,
  FileQuestion,
  FileSignature,
  FileSpreadsheet,
  Fingerprint,
  GanttChartSquare,
  Hash,
  Heart,
  History,
  Info,
  Kanban,
  KeyRound,
  Landmark,
  LayoutGrid,
  Lightbulb,
  ListChecks,
  Megaphone,
  MessageCircle,
  MessagesSquare,
  Package,
  PackageSearch,
  Palette,
  Percent,
  PiggyBank,
  Receipt,
  Repeat2,
  Ruler,
  ScrollText,
  Send,
  Settings,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Star,
  Store,
  Tags,
  Ticket,
  Truck,
  UserCog,
  UserRound,
  Wallet,
  Warehouse,
  Workflow,
  Wrench,
} = ICONES_DISPONIVEIS;

/** Ícone específico de cada rota, compartilhado entre a sidebar e o cabeçalho das telas. */
export const ICONE_POR_ROTA: Record<string, IconeMenu> = {
  "/cadastros/empresas": Building2,
  "/cadastros/bancos": Landmark,
  "/cadastros/fornecedores": Contact,
  "/cadastros/transportadoras": Store,
  "/cadastros/colaboradores": UserCog,
  "/cadastros/erros": FileQuestion,
  "/cadastros/seriais": Hash,
  "/usuarios/perfis": Fingerprint,
  "/usuarios/logins": KeyRound,
  "/auditoria/log-acesso": History,
  "/cadastros/clientes": UserRound,
  "/cadastros/produtos": Package,
  "/cadastros/detalhes": Info,
  "/cadastros/faixas-preco": Tags,
  "/cadastros/servicos": Wrench,
  "/cadastros/unidades-medida": Ruler,
  "/cadastros/categorias-estoque": Tags,
  "/cadastros/detalhes-ficha": Info,
  "/cadastros/etapas": ListChecks,
  "/cadastros/oficinas": Wrench,
  "/cadastros/locais-estoque": Warehouse,
  "/cadastros/tamanhos": Boxes,
  "/cadastros/cores": Palette,
  "/cadastros/etiquetas": Tags,
  "/cadastros/respostas-rapidas": MessagesSquare,
  "/cadastros/metas": Percent,
  "/financeiro/plano-contas": ScrollText,
  "/financeiro/maquininhas": Calculator,
  "/vendas/visao-geral": LayoutGrid,
  "/vendas": ShoppingCart,
  "/vendas/cobrancas": Banknote,
  "/vendas/pedidos": ClipboardList,
  "/area-cliente/pedidos": ClipboardList,
  "/area-cliente/chamados": Ticket,
  "/area-cliente/chat": MessageCircle,
  "/area-cliente/relatorios": FileBarChart,
  "/vendas/entregas": Truck,
  "/vendas/monitor-fiscal": Receipt,
  "/vendas/nfes-recebidas": FileCheck2,
  "/vendas/avaliacoes-atendimento": Star,
  "/vendas/relatorios": FileBarChart,
  "/compras/visao-geral": LayoutGrid,
  "/compras": ShoppingBag,
  "/compras/saldo-compras": ShoppingBag,
  "/compras/comprovantes-pagamentos": Receipt,
  "/compras/gantt": GanttChartSquare,
  "/compras/fornecedores": Contact,
  "/compras/ordem-entrega": Truck,
  "/compras/relatorios": FileBarChart,
  "/fornecedor/visao-geral": LayoutGrid,
  "/fornecedor/pedidos": ClipboardList,
  "/fornecedor/cobrancas": Receipt,
  "/fornecedor/saldo-interno": ShoppingBag,
  "/fornecedor/entregas": Truck,
  "/fornecedor/envio-nota-fiscal": FileCheck2,
  "/fornecedor/distribuicao": Boxes,
  "/fornecedor/comprovantes-pagamentos": Receipt,
  "/fornecedor/relatorios": FileBarChart,
  "/estoque/visao-geral": LayoutGrid,
  "/estoque/saldo": PackageSearch,
  "/estoque/movimentacoes": ArrowLeftRight,
  "/estoque/transferencias": Repeat2,
  "/estoque/inventario-ajuste-estoque": ClipboardCheck,
  "/estoque/relatorios": FileBarChart,
  "/financeiro/visao-geral": LayoutGrid,
  "/financeiro/receitas": ArrowDownCircle,
  "/financeiro/vendas-parceladas": Percent,
  "/financeiro/despesas": ArrowUpCircle,
  "/financeiro/comissoes": Wallet,
  "/financeiro/fluxo-caixa-diario-mensal": Banknote,
  "/financeiro/dre-gerencial-comercial": FileBarChart,
  "/financeiro/previsibilidade": CalendarClock,
  "/financeiro/relatorios": FileBarChart,
  "/suporte/visao-geral": LayoutGrid,
  "/suporte": Ticket,
  "/suporte/ativacoes": ClipboardCheck,
  "/suporte/kanban": Kanban,
  "/suporte/calendario": Calendar,
  "/suporte/chat": MessageCircle,
  "/suporte/externo": Truck,
  "/suporte/orcamentos": Calculator,
  "/suporte/avaliacoes-atendimento": Star,
  "/producao/visao-geral": LayoutGrid,
  "/producao/formatacao": SlidersHorizontal,
  "/producao/lista": ListChecks,
  "/producao/controle": Workflow,
  "/producao/kanban": Kanban,
  "/producao/calendario": Calendar,
  "/producao/gantt": GanttChartSquare,
  "/producao/oficinas": Briefcase,
  "/producao/estoque": Warehouse,
  "/producao/impressoes-dtf": Ruler,
  "/producao/vendas-dtf": MessageCircle,
  "/producao/comprovantes-dtf": Receipt,
  "/producao/avarias": FileQuestion,
  "/producao/comissoes": Wallet,
  "/producao/expedicao": Send,
  "/producao/checklists": ListChecks,
  "/producao/avaliacoes-atendimento": Star,
  "/producao/relatorios": FileBarChart,
  "/suporte/relatorios": FileBarChart,
  "/plataforma/chat-interno": MessagesSquare,
  "/checklists": ListChecks,
  "/workflow": Workflow,
  "/documentos-ia": FileSignature,
  "/bloco-notas": BookOpenCheck,
  "/protocolo": ClipboardCheck,
  "/agenda-digital": CalendarClock,
  "/caixa-sugestao": Lightbulb,
  "/pesquisa-satisfacao": Star,
  "/ajuda": Sparkles,
  "#onboarding": Info,
  "/fiscal": FileSpreadsheet,
  "/crm": Megaphone,
  "/recursos-humanos": Heart,
  "/departamento-pessoal": Briefcase,
  /* Configurações não está no menu lateral, então precisa do ícone declarado
     aqui para o cabeçalho da tela não ficar sem a engrenagem. */
  "/configuracoes": Settings,
};

function normalizarRota(pathname: string): string {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "");
}

/* Nome do ícone a partir do componente — o seletor grava o NOME, não o
   componente, então precisa do caminho inverso de ICONES_DISPONIVEIS. */
const NOME_POR_ICONE = new Map<IconeMenu, string>(
  Object.entries(ICONES_DISPONIVEIS).map(([nome, Icone]) => [Icone, nome])
);

export interface IconeTelaDisponivel {
  /** Nome do ícone gravado no banco. */
  nome: string;
  /** Tela que usa esse ícone no menu, para o usuário se localizar. */
  rotulo: string;
  Icone: IconeMenu;
}

/**
 * Ícones das telas do menu lateral, um por tela e na ordem do menu. Usado pelo
 * seletor de ícone da aba "Versão do Sistema": em vez de uma grade de ícones
 * soltos, o usuário escolhe pela tela a que o ícone pertence. Telas que
 * compartilham o mesmo ícone aparecem uma única vez.
 */
export function listarIconesDasTelas(): IconeTelaDisponivel[] {
  const vistos = new Set<string>();
  const lista: IconeTelaDisponivel[] = [];

  const adicionar = (rotulo: string, Icone: IconeMenu | undefined) => {
    if (!Icone) return;
    const nome = NOME_POR_ICONE.get(Icone);
    if (!nome || vistos.has(nome)) return;
    vistos.add(nome);
    lista.push({ nome, rotulo, Icone });
  };

  for (const item of menu) {
    adicionar(item.rotulo, ICONE_POR_ROTA[item.rota ?? ""] ?? item.Icone);
    for (const subitem of item.subitens ?? []) {
      adicionar(subitem.rotulo, ICONE_POR_ROTA[subitem.rota] ?? item.Icone);
    }
  }

  /* Fecha com o que existe no catálogo e não está no menu, para nunca faltar
     ícone — inclusive o de Configurações, que não fica na sidebar. */
  for (const [nome, Icone] of Object.entries(ICONES_DISPONIVEIS)) {
    if (vistos.has(nome)) continue;
    vistos.add(nome);
    lista.push({ nome, rotulo: nome, Icone });
  }

  return lista;
}

/** Retorna exatamente o ícone usado pela sidebar para a rota informada. */
export function obterIconeMenuPorRota(pathname: string): IconeMenu | null {
  const rotaAtual = normalizarRota(pathname);
  const iconeEspecifico = ICONE_POR_ROTA[rotaAtual];
  if (iconeEspecifico) return iconeEspecifico;

  for (const item of menu) {
    if (item.rota === rotaAtual) return item.Icone;

    if (item.subitens?.some((subitem) => subitem.rota === rotaAtual)) {
      return item.Icone;
    }
  }

  return null;
}
